//@flow
export const CHART_TABS_ID = {
  BUBBLE: "bubblesChart",
  ENTITY: "entityChart",
  ENTITY_HISTORY: "entityHistoryChart",
  RANKING: "rankingChart"
};

export type ChartTabType = $Keys<typeof CHART_TABS_ID>;
